module.exports = __webpack_public_path__ + "static/bg-grey-10a911bfd32b2cb270d9e4322e7dad79.jpg";